import QuizPage from './QuizPage';
export default QuizPage;
